import React from 'react'

import { Form, Col } from '_zari/core'

const TipoReporteOrdenFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const tiposReporteOrden = [
    {
      _id: 'compra',
      nombre: 'Ordenes Compra'
    },
    {
      _id: 'servicio',
      nombre: 'Ordenes Servicio'
    }
  ]

  const onChangeTipoReporte = tipoSeleccionado => {
    values.tipoReporte = tipoSeleccionado
    setValues(values)
  }

  return (
    <Form.Group>
      <Form.Label text='Tipo Reporte' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select
          disabled={fIsSubmitting}
          id='select-type-report'
          value={values.tipoReporte}
          onChange={e => onChangeTipoReporte(e.target.value)}
        >
          <option value=''>Seleccionar</option>
          {tiposReporteOrden.map(x => (
            <option key={x._id} value={x._id}>
              {x.nombre}
            </option>
          ))}
        </Form.Select>
        {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoReporteOrdenFormGroup)
